import firebase from 'firebase'
import _ from 'underscore'
import { v4 as uuidv4 } from 'uuid';

export default {
  createNewCard(type) {
    if (type == 'question_answer') {
      return {
        created: new Date(),
        uid: firebase.auth().currentUser.uid,
        identifier: uuidv4(),
        question: '',
        question_image : '',
        answer: '',
        answer_image: '',
        learnMore: '',
        learnMore_image: '',
        type: 'question_answer'
      }
    }
    else if (type == 'labeled_image') {
      return {
        created: new Date(),
        uid: firebase.auth().currentUser.uid,
        identifier: uuidv4(),
        image: '',
        description: '',
        entries: [], //form {label: X, string: Y}
        type: 'labeled_image',
        annotation: null
      }
    }
    else {
      return null
    }

  },
  createNewDeck() {
    return {
      name: null,
      subject: null,
      public: false,
      uid: firebase.auth().currentUser.uid,
      created: new Date(),
      tags: [],
      domainAuth: [],
      editors: [firebase.auth().currentUser.uid]
    }
  },


  getDecks() {
    let data = {
      uid: firebase.auth().currentUser ? firebase.auth().currentUser.uid : null,
    }
    let retrieveUserDecks = firebase.functions().httpsCallable('retrieveUserDecks')

    return retrieveUserDecks(data).then(response => {
      let sorted = _.sortBy(response.data, 'created')
      return sorted
    })
  },

  getSubscribedDecks() {
    let data = {
      uid: firebase.auth().currentUser ? firebase.auth().currentUser.uid : null,
    }
    let retrieveUserSubscribedDecks = firebase.functions().httpsCallable('retrieveUserSubscribedDecks')

    return retrieveUserSubscribedDecks(data).then(response => {
      return response.data
    })
  },




  loadDeck(deckId){
    let data = {
      deckId: deckId,
      uid: firebase.auth().currentUser ? firebase.auth().currentUser.uid : null,
    }

    let retrieveDeckKnowledge = firebase.functions().httpsCallable('retrieveDeckKnowledge')

    return retrieveDeckKnowledge(data).then(response => {
      return response.data
    })
  },

  resetDeck(deckId) {
    let data = {
      deckId: deckId,
      uid: firebase.auth().currentUser ? firebase.auth().currentUser.uid : null
    }
    let resetDeckKnowledge = firebase.functions().httpsCallable('resetDeckKnowledge')
    return resetDeckKnowledge(data).then(response => {
      return response
    })
  },
  //updateDeckProgress looks at the knowledge state and updates
  updateDeckProgress() {
    let data = {
      uid: firebase.auth().currentUser.uid,
    }
    let updateDeckStates = firebase.functions().httpsCallable('updateDeckStates')
    return updateDeckStates(data)
    .then(response => {
      return response.data
    })
  },
  getUserInfo() {
    let data = {
      uid: firebase.auth().currentUser.uid,
    }
    let retrieveUserInfo = firebase.functions().httpsCallable('retrieveUserInfo')
    return retrieveUserInfo(data)
    .then(response => {
      return response.data
    })
  },
  indicateUserReviewState() {
    let data = {
      uid: firebase.auth().currentUser.uid,
    }
    let setUserReviewState = firebase.functions().httpsCallable('setUserReviewState')
    return setUserReviewState(data)
    .then(response => {
      return response.data
    })
  },





}
